/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useState, useEffect } from 'react';
import validate from 'validate.js';
import { makeStyles } from '@material-ui/styles';
import { Grid } from '@material-ui/core';
import { DialogDefault, UsuarioSelect, Dropzone } from '../../../components';
import { v4 as uuidv4 } from 'uuid';

const schema = {
  usuarioId: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  file: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
};

const useStyles = makeStyles(theme => ({
  gridContainer: {
    marginTop: 0
  },
  fieldContainer: {
    paddingBottom: '0px !important'
  },
  buttonContainer: {
    width: '100%',
  },
  contentClassName: {
    overflow: 'visible'
  },
  paperScrollPaperDialog: {
    [theme.breakpoints.up('md')]: {
      minWidth: '30vw',
      minHeight: '30vh'
    },
  },
}));

const Formulario = ({ onAdd, open, onClose, selectData }) => {
  const classes = useStyles();

  const [values, setValues] = useState({});
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (selectData) {
      setValues(selectData);
    } else {
      setValues({});
    }
  }, [selectData]);

  const onCloseLocal = () => {
    setErrors({});
    setValues({})
    onClose();
  }

  const onAddLocal = () => {
    let erros = validate(values, schema);
    setErrors(erros);
    if (!erros || Object.keys(erros).length === 0) {
      onAdd({ ...values, id: values.id || uuidv4() });
      setValues({});
    }
  };

  return (
    <DialogDefault
      open={open}
      handlerCancel={onCloseLocal}
      handlerConfirm={onAddLocal}
      title="Novo"
      confirmMessage="Adicionar"
      contentClassName={classes.contentClassName}
      maxWidth="md"
      paperScrollPaperClassName={classes.paperScrollPaperDialog}
    >
      <Grid container spacing={3} className={classes.gridContainer}>
        <Grid item xs={12} className={classes.fieldContainer}>
          <UsuarioSelect
            label="Usuário"
            onSelect={(usuarioId, usuarioNome) => setValues({ ...values, usuarioId, usuarioNome })}
            ativo
            value={values.usuarioId}
            isRequired
            error={errors && errors.usuarioId}
            multiSelect={false}
          />
        </Grid>
        <Grid item xs={12} className={classes.fieldContainer}>
          <Dropzone 
            buttonText="Arquivo"
            filesLimit={1}
            acceptedFiles={['.png', '.pdf', '.jpeg', '.jpg']}
            showGridFiles
            canDeleteFiles
            buttonClassName={classes.buttonContainer}
            error={errors && errors.file}
            onSave={files => {
              if (files != null && files.length > 0) {
                var file = files[0];
                var fileOptions = {
                  id: uuidv4(),
                  nome: file.name.split('.')[0],
                  extensao: file.name.split('.').pop(),
                  alt: file.name,
                  file,
                  new: true,
                }
                setValues({ ...values, file: fileOptions });
              } else {
                setValues({ ...values, file: null });
              }
            }}
            files={values.file != null ? [{
              file: values.file.file,
              nome: values.file.alt,
              onDelete: () => {
                setValues({ ...values, file: null });
              }
            }] : []}
          />
        </Grid>
      </Grid>
    </DialogDefault>
  );
};

export default Formulario;
